module.exports = __webpack_public_path__ + "img/6.76264728.png";